import { InjectOptions, Injector, ProviderToken } from '@angular/core';
import { PoprModalPackage } from './popr-modal.package';

/**
 * @internal
 *
 * Mixin hierarchical injector for including {@link PoprModalPackage}s when creating a component.
 */
export class PoprModalInjector implements Injector {
  constructor(
    private poprModalPackage: PoprModalPackage,
    private parentInjector: Injector
  ) {
  }

  get(token: ProviderToken<any>, notFoundValue?: any, options?: (InjectOptions & {
    optional?: false;
  }) | InjectOptions): any {
    if (token === PoprModalPackage) return this.poprModalPackage;
    return this.parentInjector.get(token, notFoundValue, options);
  }
}
